"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CheckSquare: function() {
        return CheckSquare;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const CheckSquare = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM16.6757 8.26285C17.0828 8.63604 17.1103 9.26861 16.7372 9.67572L11.2372 15.6757C11.0477 15.8824 10.7803 16 10.5 16C10.2197 16 9.95226 15.8824 9.76285 15.6757L7.26285 12.9485C6.88965 12.5413 6.91716 11.9088 7.32428 11.5356C7.73139 11.1624 8.36396 11.1899 8.73715 11.597L10.5 13.5201L15.2628 8.32428C15.636 7.91716 16.2686 7.88965 16.6757 8.26285Z",
        fill: "currentColor"
    })
}), "CheckSquare");
const _default = CheckSquare;
